/** @type {string} */
export const API_BASE_URL = "https://api-poster.uzpos.uz";

/**
 * База для логотипа и медиа Poster, если в ответе путь относительный.
 * @type {string}
 */
export const POSTER_MEDIA_BASE = "https://joinposter.com";

export function isBasicConfigured() {
  const id = "4239";
  const secret = "b8f2d9e7ba0d168a18c5a9e6d21e0564";
  return Boolean(id && secret);
}

export function getBasicAuthHeader() {
  const id = "4239";
  const secret = "b8f2d9e7ba0d168a18c5a9e6d21e0564";
  const cred = btoa(`${id}:${secret}`);
  return `Basic ${cred}`;
}

/**
 * Базовый URL страницы оплаты. В query передадутся tablet_id и account_url.
 * @type {string}
 */
export const BILLING_PAYMENT_BASE =
  (process.env.REACT_APP_BILLING_PAYMENT_BASE || "").trim() || "";

/**
 * @param {string|number|undefined} tabletId
 * @param {string} [accountUrl]
 * @returns {string | null}
 */
export function getTabletPayUrl(tabletId, accountUrl) {
  if (tabletId == null || BILLING_PAYMENT_BASE === "") {
    return null;
  }
  try {
    const u = new URL(
      BILLING_PAYMENT_BASE,
      typeof window !== "undefined" && window?.location
        ? window.location.origin
        : "http://localhost",
    );
    u.searchParams.set("tablet_id", String(tabletId));
    if (accountUrl) {
      u.searchParams.set("account_url", String(accountUrl).trim());
    }
    return u.toString();
  } catch {
    return null;
  }
}

/**
 * Базовый URL страницы пополнения баланса. В query: account_url, при необходимости client_id.
 * @type {string}
 */
export const BALANCE_TOPUP_BASE =
  (process.env.REACT_APP_BALANCE_TOPUP_BASE || "").trim() || "";

/**
 * @param {string} accountUrl
 * @param {string|undefined} [clientId] Mongo/строка id клиента
 * @param {number|undefined} [amountSom] сумма пополнения в сумах (для query `amount`)
 * @returns {string | null}
 */
export function getBalanceTopUpUrl(accountUrl, clientId, amountSom) {
  const acc = (accountUrl || "").trim();
  if (!acc || BALANCE_TOPUP_BASE === "") {
    return null;
  }
  try {
    const u = new URL(
      BALANCE_TOPUP_BASE,
      typeof window !== "undefined" && window?.location
        ? window.location.origin
        : "http://localhost",
    );
    u.searchParams.set("account_url", acc);
    if (clientId) {
      u.searchParams.set("client_id", String(clientId).trim());
    }
    if (
      amountSom != null &&
      typeof amountSom === "number" &&
      Number.isFinite(amountSom)
    ) {
      u.searchParams.set("amount", String(Math.round(amountSom)));
    }
    return u.toString();
  } catch {
    return null;
  }
}
